import { Controller } from "@hotwired/stimulus"
import { focusMainForKeyboardScroll } from "../../src/main_keyboard_scroll"

// Widok zadania: PgUp/PgDn przewijają treść od razu po wejściu, bez klikania w nią.
// Po connect (pełne wczytanie i wizyta Turbo) przenosi fokus na <main> layoutu, o ile fokusu
// nie ma już pole formularza. requestAnimationFrame daje pierwszeństwo autofocusowi i kontrolerom,
// które ustawiają fokus zaraz po connect.
export default class extends Controller {
  connect() {
    this.frame = requestAnimationFrame(() => focusMainForKeyboardScroll(document, this.element.closest("main")))
  }

  disconnect() {
    cancelAnimationFrame(this.frame)
  }
}
